import {clearCookie} from './cookies';

const refreshPage = () => {
    clearCookie();
    window.location = `${window.location.origin}`;
};

function checkDetails(detail) {
    switch (detail) {
        case 401:
            refreshPage();
            break;
        case 'Authentication Required: Expired Cognito Token':
            refreshPage();
            break;
        case 'Authentication Required: Login Limit Exceed':
            refreshPage();
            break;
        case 'Authenticated user is not a customer':
        case 'Access Denied.':
            refreshPage();
            break;
        case 'Authentication Required: Full authentication is required to access this resource.':
        case 'Authentication Required: Invalid Cognito Token':
            refreshPage();
            break;
        default:
    }
}

export {checkDetails};
